<template>
  <div class="home">
    <section>
      <form class="home__filters mb-2">
        <label>
          Type
          <select v-model="filters.bonusType">
            <option value=""></option>
            <option
              v-for="{ value, text } in bonusTypes"
              :key="value"
              :value="value"
            >
              {{ text }}
            </option>
          </select>
        </label>

        <label>
          Annual Fee
          <select v-model="filters.annualFee">
            <option value=""></option>
            <option
              v-for="{ value, text } in annualFees"
              :key="value"
              :value="value"
            >
              {{ text }}
            </option>
          </select>
        </label>

        <label>
          Spend Per Month
          <select v-model="filters.requirement">
            <option value=""></option>
            <option
              v-for="{ value, text } in requirements"
              :key="value"
              :value="value"
            >
              {{ text }}
            </option>
          </select>
        </label>

        <input type="reset" @click="clearFilters" value="Clear" />
      </form>
    </section>

    <VAsync :await="request">
      <template #pending>
        <div class="flex justify-center"><PLoader /></div>
      </template>

      <!-- <perxStatus :status="status" :postsShowing="filtered.length"></perxStatus> -->

      <template #resolved>
        <section class="home__grid">
          <HomeCard
            v-for="card in filtered"
            :key="card.id"
            :card="card"
            @setReminder="$emit('setReminder', $event)"
          />
        </section>
      </template>
    </VAsync>
  </div>
</template>

<script>
import HomeCard from "@/components/HomeCard.vue"
import http from "../http"

export default {
  components: {
    HomeCard,
  },

  data() {
    return {
      request: async () => {
        this.allCards = await http.get(
          "https://perxapp.com/wp-json/perx/v1/cards"
        )
      },
      allCards: [],
      filters: {
        bonusType: "",
        annualFee: "",
        requirement: "",
      },
      bonusTypes: [
        { value: "miles", text: "Airline Miles" },
        { value: "cash", text: "Cash" },
        { value: "points", text: "Points" },
      ],
      annualFees: [
        { value: "0", text: "No Annual Fee" },
        { value: "70", text: "Under $70" },
        { value: "100", text: "Under $100" },
      ],
      requirements: [
        { value: "1", text: "After First Purchase" },
        { value: "167", text: "$167" },
        { value: "334", text: "$334" },
        { value: "667", text: "$667" },
        { value: "1334", text: "$1334" },
        { value: "1667", text: "$1667" },
      ],
    }
  },

  computed: {
    filtered() {
      const { bonusType, annualFee, requirement } = this.filters
      return this.allCards.filter(card => {
        let conditions = 0
        let matched = 0

        if (bonusType) {
          conditions += 1
          matched += +(card.bonus_type === bonusType)
        }

        if (annualFee) {
          conditions += 1
          matched += +(+card.annual_fee <= +annualFee)
        }

        if (requirement) {
          conditions += 1

          if (requirement === "1") {
            matched += card.minimum_spend === "1"
          } else {
            matched +=
              parseInt(card.minimum_spend) / parseInt(card.timeframe) <
              parseInt(requirement)
          }
        }

        return matched === conditions
      })
    },

    status() {
      return {
        total: this.allCards.length,
        showing: this.filtered.length,
      }
    },
  },

  methods: {
    clearFilters() {
      this.filters = {
        bonusType: "",
        annualFee: "",
        requirement: "",
      }
    },
  },
}
</script>

<style lang="scss">
.home {
  &__filters,
  &__grid {
    display: grid;
    grid-gap: $gap;
  }

  &__filters {
    grid-template-columns: 1fr 1fr 1fr auto;
    align-items: end;
  }

  &__grid {
    grid-template-columns: repeat(auto-fit, minmax(rem(250px), 1fr));
  }
}
</style>
